import React from "react";

import TaskLayout from "./task";
import Attributes from "../contexts/attributes/attributes";

const CodingLayout = (props) => {
    return (
        <TaskLayout>
            <Attributes addSourcePage={true} coderRoles={true}>
                {props.children}
                <div id="attribute-section"></div>
            </Attributes>
        </TaskLayout>
    );
};

export default CodingLayout;
